import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoadingService} from "../../../../services/LoadingService";
import {TOAST_TYPE} from "../../../../constants/Tpiq.constants";
import {ToastService} from "../../../../services/Toast.service";
import {NumeralService} from "../../../../services/Numeral.service";
import {Session} from "../../../../services/Session";
import {TpiqSelectDropdownComponent} from "../../../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {TpiqInputSearchComponent} from "../../../../input-search/tpiq-input-search/tpiq-input-search.component";
import {TrackerPaginatedTableComponent} from "../../../../tables/tracker-paginated-table/tracker-paginated-table.component";
import {ModelBasedNumeral} from "../../../../directives/model-numeral";
import {TpiqCustomDatepicker} from "../../../../directives/tpiq-custom-datepicker";
import { evaluate } from 'mathjs';

declare const _: any;

@Component({
  selector: 'app-template-strategies',
  standalone: true,
  imports: [CommonModule, FormsModule, ModelBasedNumeral, TpiqSelectDropdownComponent, TpiqInputSearchComponent, TrackerPaginatedTableComponent,
  TpiqCustomDatepicker],
  templateUrl: './template-strategies.component.html',
  styleUrl: './template-strategies.component.scss'
})
export class TemplateStrategiesComponent implements OnInit, OnDestroy {
  org: string;
  user: string;
  @Input() strategies: any;
  @Input() clients: any;
  @Input() allStateAssociatedData: any;
  @Input() templateRates: any;
  @Input() planYear: any;
  @Input() allAssociatedData: any;
  taxStrategyTableData: any = {};
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  columns: Array<any> = [
    {name: 'strategyName', title: 'Strategy', type: 'html', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip', sortable: false},
    {name: 'strategyType', title: 'Category', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: false},
    {name: 'clientName', title: 'Payor', type: 'badge-input-search', 'status-col': true, classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: false},
    {name: 'associated', title: 'Fed Associated With', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: false},
    {name: 'stateAssociated', title: 'State Associated With', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'},
    {name: 'amount', title: 'Plan Amount', type: 'input-currency', classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip', sortable: false, format: '$0,0', skipTab: true},
    {name: 'roiAmount', title: 'Fed Tax Savings', type: 'input-currency', classes: 'input-currency pointer amount-column zero-overflow amount-column-width table-header-badge-tooltip', sortable: false, format: '$0,0', skipTab: true},
    {name: 'stateRoiAmount', title: 'State Tax Savings', type: 'input-currency', classes: 'input-currency pointer amount-column zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: ''},
    {name: 'sinceYear', title: 'Begin', type: 'input-search', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: false},
    {name: 'toYear', title: 'End', type: 'input-search', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: false},
    {name: 'goalDate', title: 'Create Task Date', type: 'date', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: false, allowPastDate: true, initAlways: true}
  ];
  years: Array<any> = [];
  hasStrategies = false;
  associatedWith: Array<any> = [
    {id: 'a627ccde-dd57-1090-cefa-fc965526a557', name: 'Effective Rate'},
    {id: '82c36191-8d6f-39e7-f711-947591551608', name: 'Marginal Rate'},
    {id: '5a314bc1-4534-0426-1db4-d18403485072', name: 'Cap Gain Rate'},
    {id: '23a5e1b2-03cf-6675-2596-0952387d4b46', name: 'C Corp Flat Rate'},
    {id: 'b870c7b6-802f-11eb-8aa0-1282986503dc', name: 'Non-deductible'},
    {id: 'f637945b-e78e-11ef-a4a7-0e0adc17208f', name: 'Market Growth Rate'},
    {id: 'ca57f1ef-ebb8-d007-66f5-59a3297f0502', name: 'SE Tax Rate'},
    {id: '393a6f91-8222-11ef-bd9d-12ff30f54e53', name: 'Full Credit'},
    {id: '454ba189-8222-11ef-bd9d-12ff30f54e53', name: 'N/A'}
  ];

  applyOptions = [
    {name: 'Payor'},
    {name: 'Fed Associated With'},
    {name: 'State Associated With'},
    {name: 'Plan Amount'},
    {name: 'Begin Year'},
    {name: 'End Year'},
    {name: 'Create Task Date'}];
  selectedOption: any = '';
  applyOptionObject: any = {
    clientId: '',
    relatedPartyName: '',
    associatedWith: '',
    stateAssociatedWith: '',
    amount: '',
    sinceYear: '',
    toYear: '',
    goalDate: ''
  };

  constructor(
    private toastService: ToastService,
    private loadingService: LoadingService,
    private changeDetectorRef: ChangeDetectorRef,
    private numeralService: NumeralService) {}

  ngOnInit() {
    this._init();
  }

  _init() {
    const base = this;
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.fillYears();
    if (this.templateRates) {
      _.each(this.allAssociatedData, (value, key) => {
        this.allAssociatedData[key] = this.allAssociatedData[key].concat(this.templateRates);
      });
    }
    if (this.strategies) {
      this.addRequiredFieldsToStrategies();
      setTimeout(() => {
        base.buildTaxStrategiesTableData(this.strategies, true);
      });
    }
  }

  addRequiredFieldsToStrategies() {
    _.each(this.strategies, (strategy) => {
      strategy.actualAmount = (strategy.actualAmount) ? strategy.actualAmount : 0;
      strategy.clientId = (strategy.clientId) ? strategy.clientId : '';
      strategy.roiAmount = (strategy.roiAmount) ? strategy.roiAmount : 0;
      strategy.stateRoiAmount = (strategy.stateRoiAmount) ? strategy.stateRoiAmount : 0;
      strategy.overriden = (strategy.overriden) ? strategy.overriden : false;
      strategy.sinceYear = (strategy.sinceYear) ? strategy.sinceYear : '';
      strategy.toYear = (strategy.toYear) ? strategy.toYear : '';
      strategy.stateAssociatedWith = (strategy.stateAssociatedWith) ? strategy.stateAssociatedWith : '';
      strategy.stateOrverriden = (strategy.stateOrverriden) ? strategy.stateOrverriden : false;
      strategy.goalDate = (strategy.goalDate) ? strategy.goalDate : '';
      this.calculateResultAmount(strategy);
      this.calculateStateResultAmount(strategy);
    });

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  buildTaxStrategiesTableData(data, refreshTable?) {
    const base = this;
    this.taxStrategyTableData.options = {
      selectorString: 'id',
      showSearch: false,
    };
    this.taxStrategyTableData.columns = [];
    this.taxStrategyTableData.columns = this.formatColumns(this.columns);
    this.taxStrategyTableData.columns.push({name: 'actions', classes: 'overflow-css', title: '', type: 'html', sortable: false});
    if (refreshTable) {
      this.taxStrategyTableData.rows = [];
    } else {
      this.taxStrategyTableData.rows = this.taxStrategyTableData.rows || [];
    }
    const rows = base.taxStrategyTableData.rows || [];
    data.forEach(function(tax){
      const row = base.createTableRow(tax);
      rows.push(row);
    });
    this.taxStrategyTableData = {...this.taxStrategyTableData, rows};
    if (refreshTable) {
      this.hasStrategies = false;
    }
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
    base.hasStrategies = true;
    this.loadingService.triggerLoadingEvent(false);
  }

  formatColumns(columns){
    const base = this;
    const resultArray = [];
    _.each(columns, function(column){
      if (column.name == 'clientName'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.clients, placeholder: column.title, sortable: false});
      } else if (column.name == 'associated'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, 'conditional-column': true, data: base.allAssociatedData, 'row-condition': 'strategyId', displayKey: 'name', placeholder: column.title, sortable: false});
      } else if (column.name == 'stateAssociated'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.allStateAssociatedData, placeholder: column.title, sortable: false});
      } else if (column.name == 'sinceYear'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.years, placeholder: column.title, sortable: false});
      } else if (column.name == 'toYear'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.years, placeholder: column.title, sortable: false});
      } else if (column.name == 'type'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'normal', sortable: false});
      } else {
        resultArray.push(column);
      }
    });
    return resultArray;
  }

  createTableRow(strategy) {
    const base = this;
    const row: any = {};
    _.each(strategy, function(value, key){
      if (key == 'strategyName') {
        if (strategy[key]){
          if (strategy.locked){
            row[key] = `<a class='actionOnId' data-action='info'><i class="icon ion-ios-locked-outline" style="color: #F06459; margin-right: 5px;"></i><span>${strategy[key]}</span></a>`;
          } else{
            row[key] = `<a class='actionOnId' data-action='info'><span>${strategy[key]}</span></a>`;
          }
        }
      } else if (key == 'strategyId') {
        row[key] = strategy[key];
      } else if (key == 'clientId'){
        const obj = _.find(base.clients, {id: strategy[key]});
        row.clientName = obj ? obj : null;
        row[key] = strategy[key];
      } else if (key == 'associatedWith'){
        const rates = base.allAssociatedData[strategy.strategyId] || [];
        const obj = _.find(rates, {id: strategy[key]});
        row.associated = obj ? obj : null;
      } else if (key == 'stateAssociatedWith'){
        const obj = _.find(base.allStateAssociatedData, {id: strategy[key]});
        row.stateAssociated = obj ? obj : null;
      } else if (key == 'sinceYear'){
        const obj = _.find(base.years, {id: strategy[key]});
        row.sinceYear = obj ? obj : null;
      } else if (key == 'toYear'){
        const obj = _.find(base.years, {id: strategy[key]});
        row.toYear = obj ? obj : null;
      } else if (key == 'roiAmount'){
        row[key] = base.numeralService.format('$0,0', strategy[key]);
        if (strategy.overriden){
          row['roiAmount-class'] = 'input-red';
        }
      } else if (key == 'stateRoiAmount'){
        row[key] = base.numeralService.format('$0,0', strategy[key]);
        if (strategy.stateOrverriden){
          row['stateRoiAmount-class'] = 'input-red';
        }
      } else if (key == 'dollarDifference'){
        row[key] = base.numeralService.format('$0,0', strategy[key]);
      } else if (key == 'percentageDifference'){
        row[key] = strategy[key] + '%';
      } else {
        row[key] = strategy[key];
      }
    });
    row.actions = `<a class='action' data-action='delete'><i class="material-icons strategy-action-icon delete">delete</i></a>`;
    return row;
  }

  handleAction($event) {
    const base = this;
    const action = $event.action;
    if (action === 'delete') {
      _.remove(this.strategies, (item) => {
        return item.id == $event.id;
      });
      this.buildTaxStrategiesTableData(this.strategies, true);
    } else if (action === 'edit') {
    }
  }

  removeTaxStrategy($event) {
  }

  handleError(error) {
    this.loadingService.triggerLoadingEvent(false);
    error = JSON.parse(error);
    const message = error.message ? error.message : `Failed To Perform Operation`;
    try {
      this.toastService.pop(TOAST_TYPE.error, message);
    } catch (e) {
      this.toastService.pop(TOAST_TYPE.error, message);
    }
  }

  fillYears(){
    const startYear: any = _.toNumber(this.planYear);
    const endYear: any = startYear + 10;
    for (let i = startYear; i < endYear; i++){
      this.years.push({id: i, name: i.toString()});
    }
  }

  optionSelected($event) {
    const base = this;
    const strategyLine = _.find(this.strategies, {id: $event.row.id});
    if ($event.column == 'associated'){
      strategyLine.associatedWith = $event.entry.id;
      this.calculateResultAmount(strategyLine);
    } else if ($event.column == 'stateAssociated') {
      strategyLine.stateAssociatedWith = $event.entry.id;
      this.calculateStateResultAmount(strategyLine);
    } else if ($event.column == 'clientName'){
      strategyLine.clientId = $event.entry.id;
      strategyLine.relatedPartyName = $event.entry.name;
    } else if ($event.column == 'sinceYear'){
      strategyLine.sinceYear = $event.entry.id;
    } else if ($event.column == 'toYear'){
      if ($event.entry.id < strategyLine.sinceYear){
        this.toastService.pop(TOAST_TYPE.error, 'You can\'t have the end year before the start year');
        const rows = base.taxStrategyTableData.rows || [];
        _.each(rows, (row) => {
          if (row.id == $event.row.id){
            const oldStrategyLine = _.find(base.strategies, {id: $event.row.id});
            const obj = _.find(base.years, {id: oldStrategyLine.toYear});
            row.toYear = obj ? obj : null;
          }
        });
        this.taxStrategyTableData = {...this.taxStrategyTableData, rows};
        return;
      } else{
        strategyLine.toYear = $event.entry.id;
      }
    }
    this.buildTaxStrategiesTableData(this.strategies, true);
  }

  updateInput($event) {
    const strategyLine = _.find(this.strategies, {id: $event.row.id});
    if ($event.column == 'amount'){
      if (strategyLine.amount != $event.row.amount){
        strategyLine.amount = $event.row.amount;
        this.calculateResultAmount(strategyLine);
        this.calculateStateResultAmount(strategyLine);
      }
    } else if ($event.column == 'actualAmount') {
      if (strategyLine.actualAmount != $event.row.actualAmount){
        strategyLine.actualAmount = $event.row.actualAmount;
        this.calculateResultAmount(strategyLine);
        this.calculateStateResultAmount(strategyLine);
      }
    } else if ($event.column == 'roiAmount'){
      if (strategyLine.roiAmount != $event.row.roiAmount){
        strategyLine.roiAmount = $event.row.roiAmount;
        strategyLine.overriden = true;
      }
    } else if ($event.column == 'stateRoiAmount'){
      if (strategyLine.stateRoiAmount != $event.row.stateRoiAmount){
        strategyLine.stateRoiAmount = $event.row.stateRoiAmount;
        strategyLine.stateOrverriden = true;
      }
    } else if ($event.column == 'goalDate') {
      strategyLine.goalDate = $event.row.goalDate;
    }
    this.buildTaxStrategiesTableData(this.strategies, true);
  }

  calculateResultAmount(strategy, isStateRateCalcReq?){
    const associatedWithId = strategy.associatedWith;
    if (associatedWithId){
      const multiplierRate = this.getRate(strategy, associatedWithId);
      if (strategy.actualAmount) {
        strategy.roiAmount = multiplierRate * strategy.actualAmount;
      } else {
        strategy.roiAmount = multiplierRate * strategy.amount;
      }
      strategy.overriden = false;
    } else {
      strategy.roiAmount = (strategy.actualAmount) ? strategy.actualAmount : strategy.amount;
    }
    if (isStateRateCalcReq) {
      this.calculateStateResultAmount(strategy);
    }
  }

  getRate(strategy, associatedWithId){
    let rates = this.allAssociatedData[strategy.strategyId] || [];
    if (rates.length == 0){
      rates = this.associatedWith;
    }

    const obj = _.find(rates, {id: associatedWithId});
    if (obj){
      if (obj.name == 'Effective Rate'){
        return 20 / 100;
      } else if (obj.name == 'Marginal Rate'){
        return 21 / 100;
      } else if (obj.name == 'Cap Gain Rate'){
        return 22 / 100;
      } else if (obj.name == 'C Corp Flat Rate'){
        return 21 / 100;
      } else if (obj.name == 'Market Growth Rate'){
        return 5 / 100;
      } else if (obj.name == 'SE Tax Rate'){
        return  15.3 / 100;
      } else if (obj.name == 'Full Credit'){
        // Here Full Credit means 100% credit i.e 100/100
        return 1;
      } else if (obj.name == 'N/A'){
        return 0;
      } else if (obj.formula && obj.formula.actualValuesArray && obj.formula.actualValuesArray.length > 0) {
        const fromula = (_.isString(obj.formula)) ? JSON.parse(obj.formula) : obj.formula;
        let calcVal = '';
        if (fromula.displayValuesArray && fromula.displayValuesArray.length > 0) {
          _.each(fromula.displayValuesArray, (value) => {
            if (value == 'Effective Rate') {
              calcVal += 20;
            } else if (value == 'Marginal Rate'){
              calcVal += 21;
            } else if (value == 'Cap Gain Rate'){
              calcVal += 22;
            } else if (value == 'C Corp Flat Rate'){
              calcVal += 21;
            } else if (value == 'Market Growth Rate'){
              calcVal += 5;
            } else if (value == 'SE Tax Rate'){
              calcVal += 15.3;
            } else {
              calcVal += value;
            }
          });
        }
        const result = calcVal ? evaluate(calcVal) : 0;
        return result ? (result / 100) : 1;
      } else {
        return obj.rate / 100;
      }
    } else {
      return 0;
    }
  }

  calculateStateResultAmount(strategy){
    const stateAssociatedWithId = strategy.stateAssociatedWith;
    if (stateAssociatedWithId){
      const multiplierRate = this.getStateRate(strategy, stateAssociatedWithId);
      strategy.stateRoiAmount = multiplierRate * ((strategy.actualAmount) ? strategy.actualAmount : strategy.amount);
      strategy.stateOrverriden = false;
    } else {
      strategy.stateRoiAmount = 0;
    }
  }

  getStateRate(strategy, stateAssociatedWithId){
    if (this.allStateAssociatedData && this.allStateAssociatedData.length > 0) {
      const obj = _.find(this.allStateAssociatedData, {id: stateAssociatedWithId});
      if (obj){
        let stateRate: any;
        if (obj.name === 'Full Credit') {
          // Here Full Credit means 100% credit i.e 100/100
          stateRate = 1;
        } else if (obj.name === 'N/A') {
          stateRate = 0;
        } else {
          stateRate = obj.rate / 100;
        }
        return stateRate;
      } else {
        return 0;
      }
    }
  }

  setApplyOptionValue($event) {
    this.selectedOption = $event.name;
  }

  setClientValue($event) {
    this.applyOptionObject.clientId = $event.id;
    this.applyOptionObject.relatedPartyName = $event.name;
  }

  setAssociatedValue($event, type?) {
    if (type && type == 'state') {
      this.applyOptionObject.stateAssociatedWith = $event.id;
    } else {
      this.applyOptionObject.associatedWith = $event.id;
    }
  }

  selectYear($event, key){
    this.applyOptionObject[key] = $event.entry.id;
  }

  applyOnTemplateStrategies() {
    let yearError: any = false;
    if (this.strategies && this.strategies.length > 0) {
      if (this.selectedOption == 'Payor') {
        _.each(this.strategies, (strategy) => {
          strategy.clientId = this.applyOptionObject.clientId;
          strategy.relatedPartyName = this.applyOptionObject.relatedPartyName;
        });
      } else if (this.selectedOption == 'Fed Associated With') {
        _.each(this.strategies, (strategy) => {
          strategy.associatedWith = this.applyOptionObject.associatedWith;
          this.calculateResultAmount(strategy);
        });
      } else if (this.selectedOption == 'State Associated With') {
        _.each(this.strategies, (strategy) => {
          strategy.stateAssociatedWith = this.applyOptionObject.stateAssociatedWith;
          this.calculateStateResultAmount(strategy);
        });
      } else if (this.selectedOption == 'Plan Amount') {
        _.each(this.strategies, (strategy) => {
          strategy.amount = this.applyOptionObject.amount;
          this.calculateResultAmount(strategy);
          this.calculateStateResultAmount(strategy);
        });
      } else if (this.selectedOption == 'Begin Year') {
        _.each(this.strategies, (strategy) => {
          strategy.sinceYear = this.applyOptionObject.sinceYear;
        });
      } else if (this.selectedOption == 'End Year') {
        _.each(this.strategies, (strategy) => {
          if (strategy.sinceYear && (strategy.sinceYear <= this.applyOptionObject.toYear)) {
            strategy.toYear = this.applyOptionObject.toYear;
          } else {
            yearError = true;
          }
        });
      } else if (this.selectedOption == 'Create Task Date') {
        _.each(this.strategies, (strategy) => {
          strategy.goalDate = this.applyOptionObject.goalDate;
        });
      }
      if (yearError) {
        this.toastService.pop(TOAST_TYPE.error, 'You can\'t have the end year before the start year');
      }
      this.loadingService.triggerLoadingEvent(true);
      this.buildTaxStrategiesTableData(this.strategies, true);
    }
  }

  updateGoalDate($event){
    this.applyOptionObject.goalDate = $event;
  }

}
